/**
 * Copyright
 */
export function copyrightLink() {

    const addCopyrightLink = () => {
        //Get the selected text and append the extra info
        let selection = window.getSelection();
        let page_link = '... <br><br> Leggere di più:<br>&copy; ' + document.location.href;
        let copy_text = selection + page_link;
        //Create a new div to hold the prepared text
        let new_div = document.createElement('div');
        //hide the newly created container
        new_div.style.position = 'absolute';
        new_div.style.left = '-99999px';
        //insert the container, fill it with the extended text, and define the new selection
        document.body.appendChild(new_div);
        new_div.innerHTML = copy_text;
        selection.selectAllChildren(new_div);
        window.setTimeout(function () {
            document.body.removeChild(new_div);
        }, 100);
    };
    document.addEventListener('copy', addCopyrightLink);
}

// export function disableRightClick() {
//
//     document.addEventListener("contextmenu", (event) => event.preventDefault());
//
//     document.onkeydown = function (e) {
//         // disable F12 key
//         if (e.keyCode == 123) {
//             return false;
//         }
//
//         // disable I key
//         if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
//             return false;
//         }
//
//         // disable J key
//         if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
//             return false;
//         }
//
//         // disable U key
//         if (e.ctrlKey && e.keyCode == 85) {
//             return false;
//         }
//     };
// }

export function img_lightbox(){
    /** Image lightbox **/
    document.addEventListener("DOMContentLoaded", () => {
        if ("function" === typeof PhotoSwipe5) {
            const getLargestImage = (srcsetArray) => {
                let largestSet = srcsetArray.reduce((previousSet, currentSet) => {
                    let temp_p = previousSet.trim().split(" ");
                    let width_p = parseInt(temp_p[1].replace("w", ""));
                    let temp_c = currentSet.trim().split(" ");
                    let width_c = parseInt(temp_c[1].replace("w", ""));
                    return width_c > width_p ? currentSet : previousSet;
                });
                return largestSet.trim().split(" ");
            };

            const openLightbox = (event) => {
                const wpImg = event.target;
                let imgSrc = wpImg.getAttribute("src");
                let imgW = wpImg.getAttribute("width");
                if (wpImg.getAttribute("srcset")) {
                    let srcsetArray = wpImg.srcset.split(",");
                    let largestSetArry = getLargestImage(srcsetArray);
                    imgSrc = largestSetArry[0];
                    imgW = parseInt(largestSetArry[1].replace("w", ""));
                }
                // Added on 2022-March-14, only choose from srcset if image has srcset
                if( wpImg.getAttribute('srcset') ) {
                    let srcsetArray = wpImg.srcset.split(',');
                    let largestSetArry = getLargestImage(srcsetArray);
                    imgSrc = largestSetArry[0];
                    imgW = parseInt(largestSetArry[1].replace('w',''));
                }
                let item = [
                    {
                        src: imgSrc, //wpImg.src,
                        w: imgW, //wpImg.width,
                        h: wpImg.getAttribute("height"),
                        // title: wpImg.nextElementSibling.innerText,
                    },
                ];
                const options = {
                    mainClass: "brx",
                    dataSource: item,
                };

                new PhotoSwipe5(options).init();
            };

            const wpImages = document.querySelectorAll(
                ".lmt__article__content .wp-block-image img"
            );

            if (wpImages) {
                wpImages.forEach((wpImg) => {
                    wpImg.addEventListener("click", openLightbox.bind(event), false);
                });
            }
        }
    });
}
/**
 * Scroll to top button
 */
export function scrollToTopBtn() {
    const button = document.querySelector('.lmt__scrollToTop'),
        rootElement = document.documentElement,
        showBtnAt = 0.1;

    function handleScroll() {
        // do something on scroll
        let scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
        if (rootElement.scrollTop / scrollTotal > showBtnAt) {
            //show button
            button.classList.add('lmt__scrollToTop_show');
        } else {
            //hide button
            button.classList.remove('lmt__scrollToTop_show');
        }
    }

    function scrollToTop() {
        //scroll to top logic
        rootElement.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    button.addEventListener('click', scrollToTop);
    document.addEventListener('scroll', handleScroll);
}

/**
 * ِAdding the css styles to the next item after ayat
 */
export function addCssToNextAfterAyat() {

    const ayat = document.querySelectorAll(".lmt__article__content .ayat");
    const ayat_in_surah = document.querySelectorAll(".lmt__article__content .ayat_in-surah");

    for( let i = 0; i < ayat.length; i++ )
    {
        if ( !typeof ayat_in_surah && typeof ayat) {
            let next = ayat[i].nextElementSibling;
            next.style.cssText = 'padding-bottom: 16px;';
        }
    }
}

export function curentAyatSuraLinkStyling(){
    /**
     * Styling current links
     */
    let ayat_link = document.querySelectorAll('.lmt__ayat__link');
    let surah_link = document.querySelectorAll('.lmt__surah__link');
    let w_location = window.location.href;

    for (let i = 0; i < ayat_link.length; i++) {

        ayat_link[i].addEventListener("click", function() {

            let current_ayat_link = document.getElementsByClassName("lmt__ayat__link_active");

            if (current_ayat_link.length > 0) {
                current_ayat_link[0].className = current_ayat_link[0].className.replace(" lmt__ayat__link_active", "");
            }
            this.className += " lmt__ayat__link_active";
        });

        if(ayat_link[i].href === w_location){
            ayat_link[i].className += ' lmt__ayat__link_current';
        }
    }

    for (let i = 0; i < surah_link.length; i++) {
        if(surah_link[i].href === w_location){
            surah_link[i].className += ' lmt__surah__link_current';
        }
    }
}

// export function add_id_to_donation_forms() {
//     document.addEventListener('DOMContentLoaded', function () {
//         let get_paypal_form = document.querySelector('[data-form-id="6514"]');
//         // let get_stripe_form = document.querySelector('[data-form-id="6514"]');
//         get_paypal_form.setAttribute('id', '6514');
//         // console.log(get_don_form);
//     });
// }